<template>
  <SubNavbar :items="navItems" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { usePermissions } from '@/composables/usePermissions';
import SubNavbar from '@/components/ui/SubNavbar.vue';

const { canEditCategories, canEditMenu } = usePermissions();

const navItems = computed(() => [
  { path: '/menu', label: 'Artículos' },
  { path: '/menu-categories', label: 'Categorías', condition: canEditCategories.value },
  { path: '/menu-modifiers', label: 'Modificadores', condition: canEditMenu.value },
  { path: '/promotions', label: 'Promociones', condition: canEditMenu.value }
]);
</script>
